// 🖱️ Smooth Scroll

const scrollToTarget = (e, rawTargetId, offset = 80) => {
  const targetId = rawTargetId.replace(/^#/, "");
  const target = document.getElementById(targetId);
  if (target) {
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: "smooth" });
    e.preventDefault();
  }
};

const scrollLinks = document.querySelectorAll("[data-scroll-to]");

scrollLinks.forEach((el) => {
  el.addEventListener("click", (e) => {
    const targetId = el.getAttribute("data-scroll-to");
    const offsetAttr = el.getAttribute("data-scroll-offset");
    const offset = offsetAttr ? parseInt(offsetAttr, 10) : 0;
    if (targetId) {
      scrollToTarget(e, targetId, offset);
    }
  });
});

export { scrollToTarget };
